// src/pages/ChangePassword.jsx
import { useState } from "react";
import { updatePassword, signOut } from "firebase/auth";
import { auth } from "../../firebase";
import { useNavigate } from "react-router-dom";

export default function ChangePassword() {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogoutAndRedirect = () => {
    signOut(auth)
      .catch(console.error)
      .finally(() => navigate("/login"));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (newPassword !== confirmPassword) {
      setError("Nowe hasło i potwierdzenie nie są zgodne.");
      return;
    }

    const user = auth.currentUser;
    if (!user) {
      setError("Nie jesteś zalogowany.");
      return;
    }

    setLoading(true);

    try {
      await updatePassword(user, newPassword);
      setMessage("Hasło zostało zmienione pomyślnie!");
      setNewPassword("");
      setConfirmPassword("");

      // Wyloguj użytkownika po zmianie hasła
      setTimeout(handleLogoutAndRedirect, 2000); // 2s na przeczytanie komunikatu
    } catch (err) {
      console.error(err);
      if (err.code === "auth/weak-password") {
        setError("Hasło jest za słabe (min. 6 znaków).");
      } else if (err.code === "auth/requires-recent-login") {
        setError(
          "Musisz się ponownie zalogować, aby zmienić hasło. Nastąpi wylogowanie..."
        );

        // 4 sekundy i wyloguj + redirect do logowania
        setTimeout(handleLogoutAndRedirect, 4000);
      } else {
        setError("Wystąpił błąd. Spróbuj ponownie.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-md bg-white p-8 rounded-2xl shadow-lg"
      >
        <h1 className="text-2xl font-semibold text-center mb-6">
          Zmień hasło
        </h1>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Nowe hasło
          </label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
            placeholder="••••••••"
          />
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Potwierdź nowe hasło
          </label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
            placeholder="••••••••"
          />
        </div>

        {error && (
          <p className="text-sm text-red-600 mb-4 text-center">{error}</p>
        )}

        {message && (
          <p className="text-sm text-green-600 mb-4 text-center">{message}</p>
        )}

        <button
          type="submit"
          disabled={loading}
          className="w-full py-2 rounded-lg bg-black text-white font-medium hover:bg-gray-900 transition disabled:opacity-50"
        >
          {loading ? "Zmieniam..." : "Zmień hasło"}
        </button>
      </form>
    </div>
  );
}
